import React from 'react'
import { useDispatch } from 'react-redux'
import { deleteVolume, getVolumes } from '../../../../entity/volumes/Volumes'
import { MdOutlineDelete } from 'react-icons/md'

const DeleteVolume = ({ volumeId }) => {
  const dispatch = useDispatch()

  const deleteVolumeHanlder = async volumeId => {
    const confirmed = window.confirm('Do you want to delete this volume?')

    if (confirmed) {
      await dispatch(deleteVolume({volumeId}))
      dispatch(getVolumes())
    } else {
      console.log('Delete action canceled')
    }
  }
  return (
    <MdOutlineDelete
      className='hover:cursor-pointer hover:scale-110 transition-all'
      onClick={() => deleteVolumeHanlder(volumeId)}
    />
  )
}

export default DeleteVolume
